import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded'
import { Button, Grid } from '@mui/material'
import HearingSummary from 'components/HearingSummary'
import Layout from 'layouts/Default'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import summaryService from 'services/summary.service'
import { hearingSummaryInit, HearingSummaryType } from 'types/hearing-summary.type'
import { styled } from '@mui/material/styles'
import { useReactToPrint } from 'react-to-print'

export const StyledPrintContent = styled('div')`
  .content__wrapper.print__wrapper {
    margin-top: 5rem;
    position: relative;

    @media print {
      position: relative;

      html,
      body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }

    @media print {
      .page-break {
        page-break-inside: avoid;
      }

      .content__wrapper__segment {
        margin-top: 2rem;
      }
    }

    .content__wrapper__segment {
      margin-top: 2rem;
    }
  }

  .print__wrapper {
    @media print {
      margin-top: 0 !important;
    }
  }

  .hidden-non-print {
    display: none;

    @media print {
      display: block;
    }
  }

  @page {
    size: auto;
    margin: 20mm;
  }
`

const DownloadHearing: React.FC = () => {
  const [disabled, setDisabled] = useState<boolean>(true)
  const { id: hearingId } = useParams()

  const [document, setDocument] = useState<HearingSummaryType>(hearingSummaryInit)

  const getTeenagerById = useCallback(async (): Promise<void> => {
    if (!hearingId) return
    await summaryService
      .getById(hearingId)
      .then((res) => setDocument(res.data))
      .finally(() => setDisabled(false))
  }, [hearingId])

  const componentRef = useRef(null)

  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
    documentTitle: `oitiva_${hearingId}`,
  })

  useEffect(() => {
    getTeenagerById()
  }, [getTeenagerById])

  return (
    <Layout>
      <StyledPrintContent ref={componentRef}>
        <div className='print__wrapper--outter'>
          <div className='content__wrapper print__wrapper'>
            <HearingSummary data={document} />
          </div>
        </div>
      </StyledPrintContent>

      <Grid container display='flex' justifyContent='center' sx={{ mt: 4 }}>
        <Button
          variant='contained'
          startIcon={<FileDownloadRoundedIcon />}
          onClick={handlePrint}
          sx={{ pl: 2, pr: 2 }}
          disabled={disabled}
        >
          Download
        </Button>
      </Grid>
    </Layout>
  )
}

export default DownloadHearing
